/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamDataSupportInfo
 */
export interface OWGameSteamDataSupportInfo {
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataSupportInfo
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataSupportInfo
     */
    email?: string;
}

/**
 * Check if a given object implements the OWGameSteamDataSupportInfo interface.
 */
export function instanceOfOWGameSteamDataSupportInfo(value: object): value is OWGameSteamDataSupportInfo {
    return true;
}

export function OWGameSteamDataSupportInfoFromJSON(json: any): OWGameSteamDataSupportInfo {
    return OWGameSteamDataSupportInfoFromJSONTyped(json, false);
}

export function OWGameSteamDataSupportInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamDataSupportInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function OWGameSteamDataSupportInfoToJSON(json: any): OWGameSteamDataSupportInfo {
    return OWGameSteamDataSupportInfoToJSONTyped(json, false);
}

export function OWGameSteamDataSupportInfoToJSONTyped(value?: OWGameSteamDataSupportInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'email': value['email'],
    };
}

